import React, { useEffect, useState, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View,
} from "react-native";

import { useNavigate, useLocation } from 'react-router-dom';

import { ReactComponent as SideMenuSubMoreImg } from '../../../img/ico-side-bar-menu-more.svg';
import { ReactComponent as SideMenuSubFoldImg } from '../../../img/ico-side-bar-menu-more-fold.svg';

import { SideBarItemData, SideBarSubItemData } from "./sideBarData";
import SideBarExpandedMenuSubItem from "./sideBarExpandedMenuSubItem";
import { PAGE_URL } from "../../../value/Url";


interface SideBarExpandedMenuItemProps {
    key: number,
    item: Readonly<SideBarItemData>,
    menuItemActiveCb: Function,
    activeItemIdForOpenSubItem: number,
}

export default function SideBarExpandedMenuItem(props:SideBarExpandedMenuItemProps) {
    const [menuItemContainerStyle, setMenuItemContainerStyle] = useState(className.menuItemContainer);
    const [menuItemSubIconStyle, setMenuItemSubIconStyle] = useState(className.menuSubMoreImg);
    const [menuItemMouseActiveYn, setMenuItemMouseActiveYn] = useState(false);
    const [menuItemMouseHoverYn, setMenuItemMouseHoverYn] = useState(false);

    const inactiveContainerBackgroundColor = "#212943";
    const activeContainerBackgroundColor = "#323ba6";
    const hoverContainerBackgroundColor = "#1a1f33";

    const activeContainerFontColor = "#fff";
    const inactiveContainerFontColor = "#465480";

    const navigate = useNavigate();


    useEffect(()=>{
        // 현재 화면의 URL 조회 (/detail 제거)
        const path = window.location.pathname.split("/")[1];
        
        if(path === PAGE_URL.DASHBOARD.split("/")[1])
            props.menuItemActiveCb(0);

        if(props.item.sub.some((item) => path === item.path.split("/")[1])) {
            props.menuItemActiveCb(props.item.id);
        }

    },[window.location.pathname])


    useEffect(() => {
        if(props.item.sub.length === 0) {
            if(!setCurrentPath(props.item.path)) {
                setCurrentPath(props.item.path + '/' + PAGE_URL.DETAIL_MANAGEMENT);
            }
        } else {
            for(let i = 0; i < props.item.sub.length; i++) {
                if(setCurrentPath(props.item.sub[i].path)) {
                    break;
                }

                if(setCurrentPath(props.item.sub[i].path + '/' + PAGE_URL.DETAIL_MANAGEMENT)) {
                    break;
                }
            }
        }
    },[props]);

    useEffect(() => {
        if(menuItemMouseHoverYn) {
            if(!menuItemMouseActiveYn){
                setMenuItemContainerStyle({...className.menuItemContainer, backgroundColor: hoverContainerBackgroundColor, color: inactiveContainerFontColor});
            }
        } else {
            if(menuItemMouseActiveYn) {
                setMenuItemSubIconStyle({...className.menuSubMoreImg, opacity: 1 })
                setMenuItemContainerStyle({...className.menuItemContainer, backgroundColor: activeContainerBackgroundColor, color: activeContainerFontColor});
            } else {
                setMenuItemSubIconStyle({...className.menuSubMoreImg, opacity: 0.3 })
                setMenuItemContainerStyle({...className.menuItemContainer, backgroundColor: inactiveContainerBackgroundColor, color: inactiveContainerFontColor });
            }
        }
    }, [menuItemMouseHoverYn]);

    useEffect(() => {
        if(menuItemMouseActiveYn) {
            setMenuItemSubIconStyle({...className.menuSubMoreImg, opacity: 1})
            setMenuItemContainerStyle({...className.menuItemContainer, backgroundColor: activeContainerBackgroundColor, color: activeContainerFontColor});
        } else {
            setMenuItemSubIconStyle({...className.menuSubMoreImg, opacity: 0.3})
            setMenuItemContainerStyle({...className.menuItemContainer, backgroundColor: inactiveContainerBackgroundColor, color: inactiveContainerFontColor});
        }
    }, [menuItemMouseActiveYn]);


    function setCurrentPath(itemPath) {
        const path = window.location.pathname;
        if(path === itemPath) {
            setMenuItemMouseActiveYn(true);
            return true;
        } else {
            setMenuItemMouseActiveYn(false);
            return false;
        }
    }

    function clickMenuLink(linkTarget) {
        if(props.item.sub.length === 0) {
            navigate(linkTarget);
        } else {
            if(props.item.id !== props.activeItemIdForOpenSubItem) {
                props.menuItemActiveCb(props.item.id);
            }
        }
    }

    return (
        <Fragment>
            <div style={{
                zIndex: "unset",
                border: "solid 0.5px #32384d"
            }}>
                <div
                    style={menuItemContainerStyle}
                    onClick={()=>{clickMenuLink(props.item.path)}}
                    onMouseOut={()=>{setMenuItemMouseHoverYn(false)}}
                    onMouseOver={()=>{setMenuItemMouseHoverYn(true)}}
                >
                    {
                        menuItemMouseActiveYn ? props.item.activeImgComponent : props.item.imgComponent
                    }

                    {
                        // 네비게이션 메뉴 아이콘과 텍스트 사이의 공백 처리
                        props.item.name.length > 0 && <div style={{padding: "0 0 0 11px"}}/>
                    }

                    {
                        // 네비게이션 각각의 메뉴 이름 설정
                        props.item.name
                    }

                    {
                        props.item.sub.length > 0 && props.item.id === props.activeItemIdForOpenSubItem ?
                            <SideMenuSubFoldImg style={menuItemSubIconStyle}/>
                        : props.item.sub.length > 0 ?
                            <SideMenuSubMoreImg style={menuItemSubIconStyle}/>
                        : null
                    }
                </div>
                {
                    props.item.sub.length > 0 && props.item.id === props.activeItemIdForOpenSubItem ?
                        <View style={{ paddingTop:10, paddingBottom:10,backgroundColor: "#1a1f33" }}>
                            {
                                props.item.sub.map((sub:SideBarSubItemData, index) => {
                                    return (
                                        <SideBarExpandedMenuSubItem key={index} item={sub}/>
                                    )
                                })
                            }
                        </View>
                    : null
                }
            </div>
        </Fragment>
    );
}

const className = {
    menuItemContainer: {
        height: "50px",
        display: "flex", alignItems: "center",
        padding: "0 23px",
        cursor: "pointer",
        backgroundColor: "#212943",
        zIndex: "unset",
        fontFamily: "NotoSansKR-Medium",
        fontSize: "13px",
        fontWeight: "500",
        lineHeight: "0.92",
        letterSpacing: "-0.46px",
        color: "#465480"

    },
    menuSubMoreImg: {
        marginLeft: "auto",
        opacity: 0.3,
    }
}